import { Link } from 'react-router-dom';

export default function MensagemSection() {
  return (
    <section className="relative bg-gp-graphite py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/TRABALHE-CONOSCO/EQUIPE/tc-mensagem.jpg"
          alt="Dois técnicos industriais da Pilar com EPIs em conversa técnica sobre bancada demonstrando mentoria troca de conhecimento e desenvolvimento profissional"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gp-graphite/90 via-gp-graphite/85 to-gp-graphite"></div>
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-gp-graphite via-gp-graphite-light to-gp-graphite opacity-60"></div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <div className="w-16 h-[3px] bg-gp-yellow mx-auto mb-8"></div>
          <p className="font-display text-xl md:text-3xl font-bold text-white uppercase tracking-wider leading-relaxed mb-10">
            Na Pilar, acreditamos que grandes resultados são construídos por grandes pessoas.
            Se você busca desafios, aprendizado e crescimento profissional, queremos conhecer você.
          </p>
          <div className="w-16 h-[3px] bg-gp-yellow mx-auto mb-10"></div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-400 hover:text-gp-yellow transition-colors duration-300 text-sm uppercase tracking-wider"
          >
            <i className="ri-arrow-left-line w-5 h-5 flex items-center justify-center"></i>
            Voltar para a Home
          </Link>
        </div>
      </div>
    </section>
  );
}